var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-footer tw-flex tw-justify-center tw-items-center"},[_c('p',{staticClass:"tw-mr-[0.16rem]"},[_vm._v("安徽微观信息科技有限公司")]),_c('img',{staticClass:"tw-w-[0.28rem] tw-h-[0.3rem] tw-mr-[0.08rem]",attrs:{"src":require("@/assets/home/ba_logo01.png")}}),_c('p',{staticClass:"tw-flex tw-justify-center tw-items-center"},[_vm._v("皖ICP备2021017992号-1")])])
}]

export { render, staticRenderFns }